// There can be more environment names for ephemeral environments, but we can't
// enumerate them. They should be considered as "non-prod" environments.
const ENVIRONMENT_NAMES = {
  prod: 'prod',
  train: 'train',
  qa: 'qa',
  dev: 'dev',
  local: 'local'
}

const ENVIRONMENT_NAMES_ARRAY = Object.values(ENVIRONMENT_NAMES)

export {
  ENVIRONMENT_NAMES,
  ENVIRONMENT_NAMES_ARRAY
}
